module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || "4u67rqco",
    dataset: process.env.SANITY_DATASET || "production",
  },
};
